const lbaApiMultiSelect = angular.module('app.lbaApiMultiSelect', []);

lbaApiMultiSelect.controller('lbaApiMultiSelectCtrl', require('./lbaApiMultiSelectCtrl'));
lbaApiMultiSelect.directive('lbaApiMultiSelect', require('./lbaApiMultiSelectDir'));

export default lbaApiMultiSelect;



// WEBPACK FOOTER //
// ./src/components/lbaApiMultiSelect/index.js